import styled from "styled-components";

export const SummaryCard = styled.div`
    border: 1px solid #d7dee8;
    border-radius: 2px;
    background-color: #fff;
    overflow: hidden;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
`;

export const SummaryHeader = styled.div`
    padding: 12px;
    border-bottom: 1px solid #d7dee8;
`;

export const SummaryTitle = styled.div`
    font-size: 16px;
    font-weight: 700;
    color: var(--black1);
    margin-bottom: 4px;
`;

export const SummarySubtitle = styled.div`
    font-size: 14px;
    color: var(--lightGray3);
`;

export const SummaryModulesList = styled.div`
    max-height: 450px;
    overflow-y: auto;
    scrollbar-gutter: stable;

    scrollbar-width: thin;
    scrollbar-color: var(--scrollbar-thumb-color, var(--scrollColor)) transparent;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: var(--scrollbar-thumb-color, var(--scrollColor));
        border-radius: 999px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }
`;

export const SummaryModuleItem = styled.div`
    padding: 8px 12px;
    min-height: 50px;
    display: flex;
    flex-direction: ${props => props.$isEdit ? "row" : "column"};
    align-items: ${props => props.$isEdit ? "center" : "stretch"};
    justify-content: ${props => props.$isEdit ? "space-between" : "center"};
    gap: 8px;
                                                   
`;

export const SummaryModuleInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
`;

export const SummaryModuleName = styled.div`
    font-size: 14px;
    color: var(--black1);
`;

export const SummaryModuleDetails = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
  
`;

export const SummaryModulePrice = styled.span`
    font-size: 14px;
    font-weight: 700;
    color: ${props => props.$isCredit ? "var(--green, #5cb85c)" : "var(--black1)"};
`;

export const SummaryModuleTag = styled.span`
    padding: 3px;
    border-radius: 2px;
    font-size: 10px;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    gap: 2px;
    background-color: ${props => {
        if (props.$type === "redo") return "rgba(193, 35, 44, 0.1)";
        if (props.$type === "adjustment" || props.$type === "credit") return "rgba(246, 142, 49, 0.1)";
        if (props.$type === "progression") return "rgba(57, 180, 194, 0.1)";
        return "transparent";
    }};
    color: ${props => {
        if (props.$type === "redo") return "#c1232c";
        if (props.$type === "adjustment" || props.$type === "credit") return "#f68e31";
        if (props.$type === "progression") return "var(--teal)";
        return "var(--black1)";
    }};
`;

export const SummaryFooter = styled.div`
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    @media (max-width: 768px) {
        gap: 12px;
    }
`;

export const SummaryHeaderRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 10px;
`;

export const SummaryActions = styled.div`
    display: none;
    align-items: center;
    gap: 8px;
    @media (max-width: 1024px) {
        display: flex;
    }
`;

export const SummaryToggleButton = styled.button`
    border: 1px solid var(--lightBlue);
    background: var(--white);
    color: var(--button-color);
    border-radius: 4px;
    width: 36px;
    height: 36px;
    min-width: 36px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
`;

export const MobileOnly = styled.div`
    display: none;
    @media (max-width: 1024px) {
        display: block;
    }
`;

export const ProgressTrackWrapper = styled.div`
    margin-top: 5px;
`;

export const ProgressTrackBackground = styled.div`
    width: 100%;
    height: 15px;
    border-radius: 3px;
    background-color: #edebe9;
    overflow: hidden;
`;

export const ProgressTrackFill = styled.div`
    height: 15px;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 8px;
    box-sizing: border-box;
    background-image: ${props => {
        if (props.$status === "none") {
            return "linear-gradient(90deg, var(--scrollColor) 0%, var(--scrollColor) 100%)";
        }
        if (props.$status === "error") {
            return "linear-gradient(90deg, #c1232c 0%, #ff6b6b 100%)";
        }
        return "linear-gradient(90deg, #467fcf 0%, #79b3ff 199.29%)";
    }};
    width: ${(props) => props.$percent}%;
`;

export const ProgressTrackLabel = styled.div`
    font-size: 10px;
    font-weight: 600;
    padding: 0 2px;
    text-align: center !important;
    width: 100%;
    color: var(--white);
    white-space: nowrap;
`;

export const ProgressTrackHelper = styled.div`
    margin-top: 3px;
    font-size: 10px;
    font-weight: 600;
    color: var(--lightGray3);
`;

export const SummaryRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    font-size: 14px;
`;

export const SummaryRowTitle = styled.div`
    font-weight: 400;
    color: var(--black1);
`;

export const SummaryRowAmount = styled.div`
    font-size: 12px;
    font-weight: 700;
    color: ${(props) => props.$color || "var(--black1)"};
`;

export const SummaryHelperText = styled.p`
    margin: 8px 0 0 0;
    font-size: 10px;
    line-height: 1.1;
    color: ${(props) => props.$color || "var(--gray1)"};
`;

export const SummaryTotalRow = styled.div`
    margin-top: 12px;
    padding-top: 14px;
    padding-bottom: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    border-top: 1px solid #d7dee8;
`;

export const SummaryTotalLabel = styled.span`
    color: var(--black1);
    font-size: 16px;
    font-weight: 400;
    line-height: 1;
`;

export const SummaryTotalAmount = styled.span`
    font-weight: 700;
    font-size: 20px;
    color: var(--black1);
    display: flex;
    align-items: flex-start;
    gap: 2px;
`;

export const SummaryDisclaimerBlock = styled.div`
    display: flex;
    padding-top: 8px;
    align-items: baseline;
    gap: 4px;
    font-size: 14px;
    text-wrap: pretty;
    line-height: 1.1;
    color: var(--error-color);
    font-weight: 400;
    font-family: "Segoe UI";
    unicode-bidi: isolate;
    font-style: italic;
`;

export const SummaryDisclaimer = styled.div`
    display: flex;
    padding:0;
    align-items: baseline;
    gap: 4px;
    font-size: 10px;
    text-wrap: pretty;
    line-height: 1.1;
    color: var(--error-color);
    font-weight: 400;
    font-family"Segoe UI";
    unicode-bidi: isolate;
`;

export const SummaryDisclaimerText = styled.span`
    color: var(--lightGray3);
`;

export const TotalAsterisk = styled.span`
    font-size: 10px;
    color: var(--error-color);
    font-weight: 700;
`;

// Mobile-only module summary components (from sidebar)
export const ModuleSummaryContainer = styled.div`
    display: none;
    @media (max-width: 1024px) {
        display: block;
        padding: 0;
        border-top: none;
    }
`;

export const ModuleSummaryHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const ModuleSummaryTopRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    width: 100%;
`;

export const ModuleSummaryTitleGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const ModuleSummaryTitle = styled.div`
    font-weight: 600;
    color: var(--black1);
    font-size: 12px;
`;

export const ModuleSummaryMeta = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 10px;
    color: var(--lightGray3);
`;

export const ModuleSummaryAmount = styled.div`
    font-size: 12px;
    font-weight: 700;
    color: var(--black1);
`;

export const ModuleItemsWrapper = styled.div`
    max-height: 300px;
    height: auto;
    width: 100%;
    overflow-y: auto;

    scrollbar-width: thin;
    scrollbar-color: var(--scrollbar-thumb-color, var(--scrollColor)) transparent;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: var(--scrollbar-thumb-color, var(--scrollColor));
        border-radius: 999px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }
`;

export const ModuleItemsContainer = styled.div`
    padding: 8px 0 12px 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-height: 0;
    box-sizing: border-box;
`;

export const ModuleItemRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    gap: 12px;
`;

export const ModuleItemName = styled.div`
    color: #1d1d1d;
`;

export const ModuleItemPrice = styled.div`
    font-size: 12px;
    font-weight: 700;
    color: ${(props) => (props.$isCredit ? "#5cb85c" : "#1d1d1d")};
    white-space: nowrap;
`;

export const SummarySection = styled.div`
    display: flex;
    flex-direction: column;
    padding: 4px 0;
    gap: 12px;
`;

export const MobileSummaryFooter = styled.div`
    display: none;
    @media (max-width: 1024px) {
        display: block;
        padding: 12px;
        border-top: 1px solid #d7dee8;
    }
`;
